import type { GeometryPadWidgetConfig } from '../geometrypad.model';

/**
 * Trapezoid with diagonal, altitude, and midsegment features.
 *
 * Verifiable properties:
 * - Midsegment length = (a + b) / 2 and is parallel to the bases
 * - Altitude = h (perpendicular distance between parallel sides)
 * - Area = (a + b) / 2 * h
 */
export const TRAPEZOID_FEATURES_PRESET: GeometryPadWidgetConfig = {
  id: 'trapezoid-features',
  type: 'geometrypad',
  params: {
    elements: {
      tz1: {
        type: 'Trapezoid',
        params: { a: 4, b: 8, angle: 70, h: 3 },
      },
      'diagonal.tz1': { type: 'Diagonal', params: { of: 'tz1' } },
      'altitude-D.tz1': { type: 'Altitude', params: { of: 'tz1', from: 'D' } },
      'midseg.tz1': { type: 'Midsegment', params: { of: 'tz1', edges: ['left', 'right'] } },
    },
  },
  display: {},
};
